module.exports = __webpack_public_path__ + "img/transfer_spplay.08eac685.png";